import SingleSelectDropDownComponent from "../../_utils/CommonDropdown/SingleSelectDropdown";
import SVGComponent from "../../_utils/SVGComponent";
import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";
import CommonCalendar from "../CommonCalendar";

const TransactionOccurrenceDetails = ({
  txnPayLoad,
  setTxnPayLoad,

  startDate,
  endDate,
  setStartDate,
  setEndDate,

  formatDate,

  handleDateChange,
  handleEndDateChange,

  dropdownOpen,
  setDropdownOpen,
  slotdropdownOpen,
  setSlotDropdownOpen,

  setShowDatePicker,
  setShowEndDatePicker,

  SlotMappingData,
  frequencyOptions,

  setOpenOccurrencesModal,
  weekdays,

  previewMode = false,
}) => {
  const getMinEndDate = (startDate, frequency) => {
    if (!startDate || !frequency) return null;

    const d = new Date(startDate);

    switch (frequency) {
      case "Once":
        return null;

      case "Daily":
        d.setDate(d.getDate() + 1);
        break;

      case "Weekly":
        d.setDate(d.getDate() + 7);
        break;

      case "Fortnightly":
        d.setDate(d.getDate() + 14);
        break;

      case "Monthly":
        d.setMonth(d.getMonth() + 1);
        break;

      case "Quarterly":
        d.setMonth(d.getMonth() + 3);
        break;

      case "Half yearly":
        d.setMonth(d.getMonth() + 6);
        break;

      case "Yearly":
        d.setFullYear(d.getFullYear() + 1);
        break;

      default:
        return null;
    }

    return d;
  };

  const normalizeSlot = (slot) => {
    if (!slot) return "Not Available";

    try {
      const [startRaw, endRaw] = slot.split(" - ");

      const formatToAmPm = (timeStr) => {
        if (!timeStr) return "--";

        const cleaned = timeStr.trim().replace(/\s?(AM|PM)$/i, "");
        const [hours, minutes = "00"] = cleaned.split(":");
        const date = new Date();
        date.setHours(Number(hours));
        date.setMinutes(Number(minutes));

        const formatted = date.toLocaleTimeString("en-US", {
          hour: "numeric",
          minute: "2-digit",
          hour12: true,
        });
        const [time, ampm] = formatted.split(" ");
        return (
          <>
            {time}&nbsp;
            <span className="text-font-md lowercase">{ampm}</span>
          </>
        );
      };
      return (
        <>
          {formatToAmPm(startRaw)} to {formatToAmPm(endRaw)}
        </>
      );
    } catch {
      return slot;
    }
  };
  if (previewMode) {
    const selectedSlot =
      SlotMappingData?.find((s) => s.value === txnPayLoad?.slot)?.label ||
      txnPayLoad?.slot;

    const slotText = normalizeSlot(selectedSlot);

    return (
      <div className="global-card-create flex flex-col">
        <p className="text-text-primary font-semibold text-font-md mb-margin-md">
          {TEXT?.TRANSACTION_OCCURRENCE_DETAILS}
        </p>

        <div className="flex flex-col justify-between">
          <p className="font-normal text-font-md text-text-primary mb-margin-xs">
            {txnPayLoad?.frequency || "Not available"}
          </p>
          <p className="font-normal text-font-xs text-text-secondary">
            {TEXT?.FREQUENCY}
          </p>
        </div>

        <div className="border-t border-primary-bg my-margin-sm"></div>

        <div className="flex flex-col justify-between">
          <p className="font-normal text-font-md text-text-primary mb-margin-xs">
            {txnPayLoad?.transaction_start_date
              ? formatDate(txnPayLoad?.transaction_start_date)
              : "--"}
          </p>

          <p className="font-normal text-font-xs text-text-secondary">
            {txnPayLoad?.frequency === "Once"
              ? "On date"
              : "First occurrence date"}
          </p>
        </div>
        <div className="border-t border-primary-bg my-margin-sm"></div>
        <div className="flex flex-col justify-between">
          <p className="font-normal text-font-md text-text-primary mb-margin-xs">
            {txnPayLoad?.transaction_start_date
              ? formatDate(txnPayLoad?.transaction_start_date)
              : "--"}
          </p>

          <p className="font-normal text-font-xs text-text-secondary">
            {TEXT?.START_DATE}
          </p>
        </div>

        {txnPayLoad?.frequency !== "Once" && (
          <>
            <div className="border-t border-primary-bg my-margin-sm"></div>

            <div className="flex flex-col justify-between">
              <p className="font-normal text-font-md text-text-primary mb-margin-xs">
                {txnPayLoad?.transaction_end_date
                  ? formatDate(txnPayLoad?.transaction_end_date)
                  : "--"}
              </p>
              <p className="font-normal text-font-xs text-text-secondary">
                {TEXT?.END_DATE}
              </p>
            </div>
          </>
        )}

        <div className="border-t border-primary-bg my-margin-sm"></div>

        <div className="flex flex-col justify-between">
          <p className="font-normal text-font-md text-text-primary mb-margin-xs">
            {txnPayLoad?.occurrences || "Not Available"}
          </p>
          <p className="font-normal text-font-xs text-text-secondary">
            {TEXT?.OCCURRENCES}
          </p>
        </div>

        <div className="border-t border-primary-bg my-margin-sm"></div>

        <div className="flex flex-col justify-between">
          <p className="font-normal text-font-md text-text-primary mb-margin-xs">
            {slotText}
          </p>
          <p className="font-normal text-font-xs text-text-secondary">
            {TEXT?.TIME_SLOT}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-width-full flex flex-col gap-gap-md">
      {txnPayLoad?.transaction_start_date &&
      (SlotMappingData?.length ?? 0) === 0 ? (
        <>
          <div className="w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)] flex  items-center gap-x-gap-sm p-padding-md bg-emphasis rounded-border-radius-md">
            <img
              src={ICONS?.ERROR_WHITE_CIRCLE}
              className="h-icon-md w-icon-md"
              alt="error"
            />
            <p className="text-font-sm text-text-primary">
              {TEXT?.SLOT_NOT_AVAILABLE}
            </p>
          </div>
        </>
      ) : null}
      <div className="global-card-create w-width-full lg:w-width-md lg:max-w-[var(--create-box-width)] h-[max-content]">
        <div className="gap-y-gap-md flex flex-col">
          <p className="font-semibold text-font-md text-text-primary">
            {TEXT?.TRANSACTION_OCCURRENCE_DETAILS}
          </p>

          <div className="w-width-full flex flex-col gap-y-gap-xs">
            <p className="text-font-xs text-text-secondary">
              {TEXT?.FREQUENCY}
            </p>

            <SingleSelectDropDownComponent
              options={frequencyOptions}
              selected={txnPayLoad?.frequency}
              setSelected={(val) => {
                setStartDate(null);
                setEndDate(null);
                setTxnPayLoad({
                  ...txnPayLoad,
                  frequency: val,
                  transaction_start_date: "",
                  transaction_end_date: "",
                  occurrences: "",
                  slot: "",
                });
              }}
              isOpen={dropdownOpen}
              onOpen={() => setDropdownOpen(true)}
              onClose={() => setDropdownOpen(false)}
              type="big"
              placeholder="Select frequency"
              showSearch={false}
            />
          </div>

          <div
            className="w-width-full flex flex-col gap-y-gap-md"
            style={{ display: txnPayLoad?.frequency ? "flex" : "none" }}
          >
            <div className="border-t-border border-primary-bg"></div>
            <div className="flex flex-col gap-y-gap-xs">
              <span className="text-font-xs text-text-secondary">
                {txnPayLoad?.frequency === "Once" ? "On date" : "Start date"}
              </span>

              <CommonCalendar
                startDate={startDate}
                selectionType="single"
                type="big"
                minDate={new Date()}
                handleDateChange={(date) => {
                  // if (!date) return;
                  handleDateChange(date);
                  setShowDatePicker(false);
                }}
              />
            </div>

            <div
              className="flex flex-col gap-y-gap-xs"
              style={{
                opacity: startDate
                  ? "var(--base-opacity)"
                  : "var(--light-opacity)",
                pointerEvents: startDate ? "auto" : "none",
                display: txnPayLoad?.frequency === "Once" ? "none" : "flex",
              }}
            >
              <span className="text-font-xs text-text-secondary">
                {TEXT?.END_DATE}
              </span>

              <CommonCalendar
                startDate={endDate}
                selectionType="single"
                type="big"
                minDate={getMinEndDate(startDate, txnPayLoad?.frequency)}
                handleDateChange={(date) => {
                  if (!date) return;
                  handleEndDateChange(date);
                  setShowEndDatePicker(false);
                }}
              />
            </div>

            <div
              className="w-width-full flex gap-x-gap-sm px-padding-sm"
              style={{
                display:
                  ["Once", "Weekly", "Yearly", "Monthly"].includes(
                    txnPayLoad?.frequency,
                  ) &&
                  txnPayLoad?.transaction_start_date &&
                  txnPayLoad?.transaction_end_date
                    ? "flex"
                    : "none",
              }}
            >
              <img
                src={ICONS?.DATE_CIRCLE_BLUE}
                className="h-icon-lg w-icon-lg"
                alt="calendar"
              />

              <div className="flex flex-col">
                <p className="text-font-md text-text-primary">
                  {startDate ? weekdays[new Date(startDate).getDay()] : "--"}
                </p>

                <p className="text-font-xs text-text-secondary">
                  {txnPayLoad?.frequency === "Once" ||
                  txnPayLoad?.frequency === "Weekly"
                    ? "On day"
                    : "On date"}
                </p>
              </div>
            </div>

            <div
              onClick={() => setOpenOccurrencesModal(true)}
              className="w-width-full flex items-center gap-x-gap-sm p-padding-sm cursor-pointer rounded-border-radius-md global-hover-white relative z-z-index-base"
              style={{ display: !txnPayLoad?.occurrences ? "none" : "flex" }}
            >
              <img
                src={ICONS?.OCCURENCES_CIRCLE_BLUE}
                className="h-icon-lg w-icon-lg"
                alt="occ"
              />

              <div className="flex flex-col w-width-full gap-gap-xs">
                <p className="text-font-md text-text-primary lowercase">
                  {txnPayLoad?.occurrences} {TEXT?.OCCURRENCE}/s
                </p>
                <p className="text-font-xs text-text-secondary">
                  {TEXT?.SELECT_FREQUENCY_OCCURRENCE_NOTE}
                </p>
              </div>

              <SVGComponent
                url={ICONS?.ARROW_RIGHT_WHITE}
                height="var(--icon-sm)"
                width="var(--icon-sm)"
                color="var(--text-primary)"
              />
            </div>

            {startDate && (
              <>
                {(SlotMappingData?.length ?? 0) === 0 ? null : (
                  <div className="flex flex-col gap-y-gap-xs">
                    <p className="text-font-xs text-text-secondary">
                      {TEXT?.TIME_SLOT}
                    </p>

                    <SingleSelectDropDownComponent
                      options={SlotMappingData?.map((s) => s.label)}
                      selected={
                        txnPayLoad?.slot
                          ? SlotMappingData?.find(
                              (slot) => slot.value === txnPayLoad?.slot,
                            )?.label
                          : ""
                      }
                      setSelected={(label) => {
                        const sel = SlotMappingData?.find(
                          (slot) => slot.label === label,
                        );
                        setTxnPayLoad({
                          ...txnPayLoad,
                          slot: sel?.value || "",
                        });
                      }}
                      isOpen={slotdropdownOpen}
                      onOpen={() => setSlotDropdownOpen(true)}
                      onClose={() => setSlotDropdownOpen(false)}
                      type="big"
                      placeholder={TEXT?.SELECT_TIMESLOT}
                      showSearch={false}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransactionOccurrenceDetails;
